import { render, staticRenderFns } from "./magazinesEditComponent.vue?vue&type=template&id=a27b97be&scoped=true&"
import script from "./magazinesEditComponent.vue?vue&type=script&lang=ts&"
export * from "./magazinesEditComponent.vue?vue&type=script&lang=ts&"
import style0 from "./magazinesEditComponent.vue?vue&type=style&index=0&id=a27b97be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27b97be",
  null
  
)

export default component.exports